export default "__VITE_ASSET__082ee2b3__"